const api = {
  //   url: "http://localhost:3001", // for local testing
  url: "https://warm-refuge-84962.herokuapp.com", //For remote deployment
};

export { api };



// WEBPACK FOOTER //
// ./src/apiPath.js